import { FC, ReactElement } from "react";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { FiInfo } from "react-icons/fi";

interface InfoTooltipProps {
  title: string;
  text: string;
}

const InfoTooltip: FC<InfoTooltipProps> = ({ text, title }): ReactElement => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography
        color="#030712"
        variant="h3"
        fontSize={20}
        lineHeight="26px"
        fontWeight={500}
      >
        {title}
      </Typography>
      <Tooltip
        title={text}
        placement="right"
        arrow
        slotProps={{
          popper: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -5],
                },
              },
            ],
          },
        }}
      >
        <IconButton disableRipple sx={{ padding: 0 }}>
          <FiInfo fontSize={16} color="#8E9494" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default InfoTooltip;
